import { SAVE_USER_DATA_LAMBDA_URL } from 'src/const';
import { callApi } from 'src/core/callApi';
import { updateUserMarketExplorerRowDataExportUsageAction } from 'src/store/Dashboard/actions';

export const updateUserMarketExplorerRowDataExportUsage = async (creditsUsed: number, dispatch: any) => {
  try {
    const success = await callApi(
      SAVE_USER_DATA_LAMBDA_URL,
      {
        body: {
          marketExplorerRowDataExportUsage: creditsUsed,
        },
      },
      true,
      false,
      '',
      'POST',
      true
    );
    console.log(success);

    if (success && success.user_data_updated) {
      dispatch(updateUserMarketExplorerRowDataExportUsageAction(creditsUsed));
    }
  } catch (err) {
    console.error(err);
  }
};
